import formProps from './_form-props'
import proProps from './_pro-props'

const props = {
  ...formProps,
  ...proProps
}

export const propsKeys = Object.keys(props)

export default props
